document.querySelectorAll('*[data-option-for]').forEach(function (el) {
  var target = document.getElementById(el.getAttribute('data-option-for'));
  if (!target)return;

  target.addEventListener('change', function () {
    el.style.display = target.checked ? 'block' : 'none';
  });
});

document.querySelectorAll('*[data-option-hide-for]').forEach(function (el) {
  var target = document.getElementById(el.getAttribute('data-option-hide-for'));
  if (!target)return;

  target.addEventListener('change', function () {
    el.style.display = target.checked ? 'none' : 'block';
    if(target.checked){
      el.querySelectorAll('input[type="checkbox"]').forEach(function (el) {
        el.checked = false;
      });
    }
  });
});